module.exports = __webpack_public_path__ + "static/media/Sapphire clinics uses telemedicine software for digital patient communication.961bb093.webp";